module.exports = __webpack_public_path__ + "static/media/bmob.daf9660b.ico";


//////////////////
// WEBPACK FOOTER
// ./static/images/icons/bmob.ico
// module id = 76
// module chunks = 0